import React, { useState, useEffect } from 'react'; 
import Dropdown from "../../../components/ui/dropdown";
import FilterChip from './FilterChip'; 

const AppointmentUtils = ({
  appType,
  setAppType,
  appointmentStatus,
  setAppointmentStatus,
  px = "0.75rem",
  setPage,
}) => {
  const categories = ["All", "Initial", "FollowUp"];
  const modes = ["All", "Online", "Offline"];
  const statuses = ["All", "Active", "Cancelled", "Missed", "Completed"];

  const [dropdownToOpen, setDropdownToOpen] = useState<string | null>(null);

  const handleCategoryChange = (selected: string | null) => {
    setAppType((prev) => ({
      ...prev,
      category: selected === "All" ? null : selected,
    }));
    setPage(1);
    setDropdownToOpen(null); 
  };

  const handleModeChange = (selected: string | null) => {
    setAppType((prev) => ({
      ...prev,
      mode: selected === "All" ? null : selected,
    }));
    setPage(1);
    setDropdownToOpen(null); 
  };

  const handleStatusChange = (selected: string | null) => {
    setAppointmentStatus(selected === "All" ? "" : selected); 
    setPage(1);
    setDropdownToOpen(null); 
  };

  useEffect(() => {
    if (dropdownToOpen) {
      const timer = setTimeout(() => setDropdownToOpen(null), 50);
      return () => clearTimeout(timer);
    }
  }, [dropdownToOpen]);

  const currentCategory = appType.category;
  const isCategorySelected = currentCategory && currentCategory !== "All";

  const currentMode = appType.mode;
  const isModeSelected = currentMode && currentMode !== "All";

  const currentStatus = appointmentStatus;
  const isStatusSelected = currentStatus && currentStatus !== "All" && currentStatus !== "";

  return (
    <div
      className="w-full flex flex-col sm:flex-row sm:flex-wrap items-center gap-2 pb-2"
      style={{ paddingLeft: px, paddingRight: px }}
    >
      {isCategorySelected ? (
        <FilterChip
          label={`Category: ${currentCategory}`}
          onClear={() => {
            setAppType(prev => ({ ...prev, category: null }));
            setPage(1);
            setDropdownToOpen('category');
          }}
        />
      ) : (
        <Dropdown
          onSelect={handleCategoryChange}
          options={categories}
          className="!h-[40px] w-full sm:w-auto sm:min-w-[150px] flex-grow sm:flex-grow-0"
          prefixText="Category:"
          value={currentCategory || "All"}
          valueFont="600"
          triggerOpen={dropdownToOpen === 'category'} 
          onDropdownClose={() => setDropdownToOpen(null)} 
        />
      )}

      {isModeSelected ? (
        <FilterChip
          label={`Mode: ${currentMode}`}
          onClear={() => {
            setAppType(prev => ({ ...prev, mode: null }));
            setPage(1);
            setDropdownToOpen('mode');
          }}
        />
      ) : (
        <Dropdown
          onSelect={handleModeChange}
          options={modes}
          className="!h-[40px] w-full sm:w-auto sm:min-w-[150px] flex-grow sm:flex-grow-0"
          prefixText="Mode:"
          value={currentMode || "All"}
          valueFont="600"
          triggerOpen={dropdownToOpen === 'mode'} 
          onDropdownClose={() => setDropdownToOpen(null)} 
        />
      )}

      {isStatusSelected ? (
        <FilterChip
          label={`Status: ${currentStatus}`}
          onClear={() => {
            setAppointmentStatus(""); 
            setPage(1);
            setDropdownToOpen('status');
          }}
        />
      ) : (
        <Dropdown
          onSelect={handleStatusChange}
          options={statuses}
          className="!h-[40px] w-full sm:w-auto sm:min-w-[150px] flex-grow sm:flex-grow-0"
          prefixText="Status:"
          value={currentStatus || "All"}
          valueFont="600"
          triggerOpen={dropdownToOpen === 'status'}
          onDropdownClose={() => setDropdownToOpen(null)}
        />
      )}
    </div>
  );
};

export default AppointmentUtils;